import apiEndPoints from "../../../routeConfig";
import { ApiService } from "../../../../service/api.service";

const apiService = new ApiService();

export const getEmailConfiguration = async () => {
  try {
    const response = await apiService.get(apiEndPoints.emailConfiguration);
    // ApiService.get returns the full axios response.
    return response?.data ?? response;
  } catch (error) {
    return error;
  }
};

export const updateEmailConfiguration = async (liveSendingEnabled) => {
  try {
    // ApiService.update returns response.data directly.
    const response = await apiService.update(apiEndPoints.emailConfiguration, {
      liveSendingEnabled,
    });
    return response;
  } catch (error) {
    return error;
  }
};

export const getSmsConfiguration = async () => {
  try {
    const response = await apiService.get(apiEndPoints.smsConfiguration);
    return response?.data ?? response;
  } catch (error) {
    return error;
  }
};

export const updateSmsConfiguration = async (liveSendingEnabled) => {
  try {
    const response = await apiService.update(apiEndPoints.smsConfiguration, {
      liveSendingEnabled,
    });
    return response;
  } catch (error) {
    return error;
  }
};
